import { type AvatarConfig } from '@/lib/avatar-utils'

interface AvatarOptionProps {
  title: string
  value: string | boolean
  options: Array<{ value: string; label: string }> | 'boolean'
  onChange: (value: string | boolean) => void
  config: AvatarConfig
}

const AvatarOption = ({ title, value, options, onChange }: AvatarOptionProps) => {
  if (options === 'boolean') {
    return (
      <div className="form-control">
        <label className="label">
          <span className="label-text font-medium">{title}</span>
        </label>
        <label className="cursor-pointer label justify-start gap-2">
          <input
            type="checkbox"
            className="toggle toggle-primary"
            checked={value as boolean}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span className="label-text">{value ? 'Yes' : 'No'}</span>
        </label>
      </div>
    )
  }

  return (
    <div className="form-control">
      <label className="label">
        <span className="label-text font-medium">{title}</span>
      </label>
      <select
        className="select select-bordered select-sm"
        value={value as string}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default AvatarOption